// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8957b1ce","732":"81fb86fa","977":"e1a7cc08"}[chunkId] + ".chunk.js";
};